import React, { memo } from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

function SideHours({ hours }) {
  const { Typography } = useUiContext();

  return (
    <div className="hourcolumn">
      {hours.map((hour) => (
        <div key={hour} className="hourscale">
          <Typography>{hour}</Typography>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      ))}
    </div>
  );
}

SideHours.propTypes = {
  hours: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default memo(SideHours);
